/* ================================
   BANNERS INTERMEDIOS – COLLECTION
   (JSON + Imagen / Video)
================================ */

(function () {

  let bannerTimeout = null;

  /**
   * Crea un banner:
   * - Prioriza video
   * - Fallback a imagen
   * - Video autoplay / muted / loop / sin controles
   */
  function createBannerItem({ image, video, link, index }) {
    const bannerClass = `imagen-collection-page__middle imagen-collection-page__middle--${index}`;

    let mediaHTML = '';

    if (video) {
      mediaHTML = `
        <video
          src="${video}"
          autoplay
          muted
          loop
          playsinline
          preload="metadata"
        ></video>
      `;
    } else if (image) {
      mediaHTML = `<img src="${image}" alt="">`;
    } else {
      return null;
    }

    return $(`
      <div class="product-item-imagen ${bannerClass}">
        <div class="container-imagen">
          ${
            link
              ? `<a href="${link}" target="_blank">${mediaHTML}</a>`
              : mediaHTML
          }
        </div>
      </div>
    `);
  }

  function handleCollectionBanners() {
    const $grid = $('#CollectionLoop[data-globo-filter-items]');
    if (!$grid.length) return;

    // 🔒 Lock anti-loop
    if ($grid.data('banners-processing')) return;
    $grid.data('banners-processing', true);

    const rawData = $grid.attr('data-collection-banners');
    if (!rawData) {
      $grid.removeData('banners-processing');
      return;
    }

    let bannersData;
    try {
      bannersData = JSON.parse(rawData);
    } catch (e) {
      console.error('[BANNERS] JSON inválido', e);
      $grid.removeData('banners-processing');
      return;
    }

    const banners = bannersData.banners || [];
    if (!banners.length) {
      $grid.removeData('banners-processing');
      return;
    }

    const $products = $grid.find(
      '.product-item[data-product-grid-item]'
    );

    banners.forEach((banner, i) => {
      const positionIndex = banner.position - 1;
      if ($products.length <= positionIndex) return;

      const bannerClass = `.imagen-collection-page__middle--${i + 1}`;
      if ($grid.find(bannerClass).length) return;

      const $bannerItem = createBannerItem({
        image: banner.image,
        video: banner.video,
        link: banner.link,
        index: i + 1
      });

      if ($bannerItem) {
        $products.eq(positionIndex).after($bannerItem);
      }
    });

    // 🔓 Unlock
    setTimeout(() => {
      $grid.removeData('banners-processing');
    }, 80);
  }

  function BannerGloboLoad(mutationsList) {
    for (const mutation of mutationsList) {
      if (
        mutation.type === 'childList' &&
        $(mutation.target).is('.product-grid-global__custom-ittd')
      ) {
        clearTimeout(bannerTimeout);

        bannerTimeout = setTimeout(() => {
          handleCollectionBanners();
        }, 80);

        break;
      }
    }
  }

  const bannerObserver = new MutationObserver(BannerGloboLoad);
  bannerObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Primera carga
  document.addEventListener('DOMContentLoaded', handleCollectionBanners);

})();
